import React from "react";
import { Route, Switch } from "react-router-dom";

import Login from "../auth/Login/Login";
import { Alert, ReduxProtectedRoute } from "@leap4/frontend";
import { requiredAuthRoles, BACKEND_SERVICE_NAME } from "../../config/generals";
import { urlService } from "./urlsService";

import ReportingModule from "../modules/reporting";
import Dashboard from "../modules/dashboard";
import { ProjectionRoute } from "../modules/projection/ProjectionRoute";

const Routes = () => {
    return (
        <>
            <Alert />
            <Switch>
                <Route exact path="/login" component={Login} />

                <ReduxProtectedRoute
                    exact={true}
                    backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={Dashboard}
                    path={urlService.dashboard()}
                />

                <ReduxProtectedRoute
                    exact={true}
                    backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={ProjectionRoute}
                    path={urlService.projection()}
                />

                <ReduxProtectedRoute
                    exact={true}
                    backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={ReportingModule}
                    path={urlService.reporting()}
                />

                <ReduxProtectedRoute
                    exact={true}
                    backendServiceName={BACKEND_SERVICE_NAME}
                    requiredRoles={requiredAuthRoles}
                    component={Dashboard}
                    path="/"
                />

                <Route component={Login} />
            </Switch>
        </>
    );
};

export default Routes;
